/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/default-props-match-prop-types */
import React, { FC, HTMLAttributes, ReactNode, ReactNodeArray, Ref } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib';
import { textFontSizes, textFontWeights, textLineHeights, resetedLineHeight } from '@shared/config/text';
export interface OldTextProps extends Omit<HTMLAttributes<HTMLDivElement>, 'as'> {
  textRef?: Ref<HTMLDivElement>;
  sizemob?: 'sm' | 'md' | 'lg' | 'xl';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: string;
  capitalize?: boolean;
  fontWeight?: 'regular' | 'medium' | 'bold' | 'black';
  resetLineHeight?: boolean;
  as?: 'div' | 'span' | 'p';
  align?: 'left' | 'center' | 'right' | 'inherit';
  checked?: boolean;
  children?: ReactNode | ReactNodeArray;
  nowrap?: boolean;
  // TODO все пропсы ниже - удаллить deprecated
  reset?: boolean;
  biDir?: boolean;
  firstChild?: boolean;
  hintMargin?: string;
}
const OldText: FC<OldTextProps> = ({
  textRef,
  children,
  fontWeight,
  color,
  ...restProps
}) => <Wrapper ref={textRef} weight={fontWeight} data-testid="text" $color={color} {...restProps}>
    {children}
  </Wrapper>;
interface WrapperProps extends Pick<OldTextProps, 'sizemob' | 'size' | 'resetLineHeight' | 'align' | 'capitalize' | 'nowrap'> {
  weight?: 'regular' | 'medium' | 'bold' | 'black';
  $color?: OldTextProps['color'];
}

// @ts-ignore
const _exp = /*#__PURE__*/() => ({
  nowrap
}) => nowrap ? 'nowrap' : 'pre-line';
const _exp2 = /*#__PURE__*/() => ({
  theme
}: ThemeProps) => theme.font.family.MTSSans;
const _exp3 = /*#__PURE__*/() => ({
  sizemob,
  size
}) => textFontSizes.par[sizemob as 'sm' || size];
const _exp4 = /*#__PURE__*/() => ({
  weight
}) => textFontWeights[weight as 'regular'];
const _exp5 = /*#__PURE__*/() => ({
  sizemob,
  size,
  resetLineHeight
}) => resetLineHeight ? resetedLineHeight : `${textLineHeights.par[sizemob as 'sm' || size]}px`;
const _exp6 = /*#__PURE__*/() => ({
  align
}) => align || '';
const _exp7 = /*#__PURE__*/() => ({
  capitalize
}) => capitalize ? 'uppercase' : 'none';
const _exp8 = /*#__PURE__*/() => ({
  $color
}) => $color || '';
const _exp9 = /*#__PURE__*/() => ({
  size
}) => textFontSizes.par[size as 'sm'];
const _exp0 = /*#__PURE__*/() => ({
  size,
  resetLineHeight
}) => resetLineHeight ? resetedLineHeight : `${textLineHeights.par[size as 'sm']}px`;
const Wrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wf31upr",
  propsAsIs: false,
  vars: {
    "wf31upr-0": [_exp()],
    "wf31upr-1": [_exp2()],
    "wf31upr-2": [_exp3(), "px"],
    "wf31upr-3": [_exp4()],
    "wf31upr-4": [_exp5()],
    "wf31upr-5": [_exp6()],
    "wf31upr-6": [_exp7()],
    "wf31upr-7": [_exp8()],
    "wf31upr-8": [_exp9(), "px"],
    "wf31upr-9": [_exp0()]
  }
}));
OldText.defaultProps = {
  size: 'lg',
  sizemob: 'md',
  align: 'left',
  fontWeight: 'regular',
  as: 'div',
  color: '#000000',
  capitalize: false,
  resetLineHeight: false,
  nowrap: false
};
export default OldText;

require("./OldText.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./OldText.tsx");